<template>
  <div id="app">
    <router-view/>
    <pto-approval-modal/>
    <timecard-details-modal/>
    <create-payment-modal/>
  </div>
</template>

<script>
  import PtoApprovalModal from "./components/ptos/PtoApprovalModal";
  import TimecardDetailsModal from "./components/timecards/TimecardDetailsModal";
  import themeConfig from '../themeConfig.js'
  import CreatePaymentModal from "./components/payments/CreatePaymentModal";
  import Notifications from "./services/Notifications";

  export default {
    data () {
      return {
        channelId: null
      }
    },
    components: {
      CreatePaymentModal,
      PtoApprovalModal,
      TimecardDetailsModal,
    },
    watch: {
      '$store.state.theme' (val) {
        this.toggleClassInBody(val);
      }
    },
    methods: {
      toggleClassInBody (className) {
        if (className === 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
          document.body.classList.add('theme-dark');
        } else if (className === 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
          document.body.classList.add('theme-semi-dark');
        } else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        }
      },
      handleWindowResize (event) {
        this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
      },
      getCounters () {
        const token = localStorage.getItem('access_token');
        if (token) {
          this.$store['dispatch']('getUnreadNotifications');
        }
      },
      getMe () {
        this.$store['dispatch']('me').then((user) => {
          this.channelId = user.channel_id;
          const channel = this.$pusher.subscribe(`user.${this.channelId}`);
          channel.bind('NotificationSent', ({notification}) => {
            this.$store['dispatch']('getUnreadNotifications');
            this.$notificationService.notificationPopup(Notifications.preparePushData(notification, this)).then(() => {
              Notifications.manageRedirection(notification, this);
            });
          });
        });
      }
    },
    mounted () {
      this.toggleClassInBody(themeConfig.theme);
      this.$nextTick(() => {
        window.addEventListener('resize', this.handleWindowResize);
      });
      this.$store.dispatch('updateWindowWidth', window.innerWidth);
      localStorage.setItem('lang', 'it');
      if (this.$store.getters.isAuth) {
        this.getCounters();
        this.getMe();
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleWindowResize);
      if (this.channelId) {
        this.$pusher.unsubscribe(this.channelId);
      }
    },
  }

</script>
